var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-select',{attrs:{"options":_vm.currencies,"track-by":"currency_name","allow-empty":false,"custom-label":_vm.formatLabel},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }